import { render, staticRenderFns } from "./studentDoor.vue?vue&type=template&id=7ae74eaf&scoped=true&"
import script from "./studentDoor.vue?vue&type=script&lang=js&"
export * from "./studentDoor.vue?vue&type=script&lang=js&"
import style0 from "./studentDoor.vue?vue&type=style&index=0&id=7ae74eaf&scoped=true&lang=scss&"
import style1 from "./studentDoor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae74eaf",
  null
  
)

export default component.exports